export default {
  CUSTOMER: 'customer',
  SUPPLIER: 'supplier',
};



// WEBPACK FOOTER //
// ./src/variables/ski/school/comment-type.enums.js